/* @generated */
"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
  return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var props = __getOwnPropSymbols(b), i = 0, n = props.length, prop; i < n; i++) {
      prop = props[i];
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = function(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __export = function(target, all) {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = function(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function")
    for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
      key = keys[i];
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: function(k) {
          return from[k];
        }.bind(null, key), enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
  return to;
};
var __toESM = function(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  );
};
var __toCommonJS = function(mod) {
  return __copyProps(__defProp({}, "__esModule", { value: true }), mod);
};

// ../src/modal/index.ts
var modal_exports = {};
__export(modal_exports, {
  Modal: function() {
    return Modal;
  }
});
module.exports = __toCommonJS(modal_exports);

// ../src/modal/modal.tsx
var import_classnames7 = __toESM(require("classnames"));
var React7 = __toESM(require("react"));
var import_react_modal = __toESM(require("react-modal"));
var import_focus_visible = require("focus-visible");
var import_layer = require("@dropbox/dig-components/layer");
var import_dig_foundations = require("@dropbox/dig-foundations");
var import_buttons = require("@dropbox/dig-components/buttons");
var import_dig_icons = require("@dropbox/dig-icons");
var import_assets = require("@dropbox/dig-icons/assets");

// ../src/modal/content.tsx
var React = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));

// ../src/modal/index.css.ts
var import_createRuntimeFn = require("@vanilla-extract/recipes/createRuntimeFn");
var modalBodyRecipe = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1w9fcz97_21-1-1", variantClassNames: { hasVerticalSpacing: { true: "dig-1w9fcz98_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var modalCloseButtonStyle = "dig-1w9fcz9h_21-1-1";
var modalContentStyle = "dig-1w9fcz9a_21-1-1";
var modalFooterRecipe = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1w9fcz9d_21-1-1", variantClassNames: { preferComposition: { true: "dig-1w9fcz9e_21-1-1", false: "dig-1w9fcz9f_21-1-1" }, hasTopBorder: { true: "dig-1w9fcz9g_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var modalFullWidthStyle = "dig-1w9fcz99_21-1-1";
var modalHeaderRecipe = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1w9fcz95_21-1-1", variantClassNames: { marginTitleStandard: { true: "dig-1w9fcz96_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var modalHtmlStyle = "dig-1w9fcz9i_21-1-1";
var modalOverlayStyle = "dig-1w9fcz9b_21-1-1";
var modalRecipe = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1w9fcz92_21-1-1", variantClassNames: { isCentered: { true: "dig-1w9fcz93_21-1-1" }, fullScreen: { true: "dig-1w9fcz94_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var modalTitleStyle = "dig-1w9fcz9c_21-1-1";

// ../src/modal/content.tsx
var _excluded = ["children", "className"];
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Content = function(_ref) {
  var children = _ref.children, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */ React.createElement("div", __spreadValues({ className: (0, import_classnames.default)("dig-Modal-content", modalContentStyle, className) }, rest), children);
};

// ../src/modal/header.tsx
var React2 = __toESM(require("react"));
var import_classnames2 = __toESM(require("classnames"));
var _excluded2 = ["hasBottomSpacing", "children", "className"];
function _objectWithoutProperties2(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose2(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Header = function(_ref) {
  var _ref$hasBottomSpacing = _ref.hasBottomSpacing, hasBottomSpacing = _ref$hasBottomSpacing === void 0 ? "title-small" : _ref$hasBottomSpacing, children = _ref.children, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, rest = _objectWithoutProperties2(_ref, _excluded2);
  var cls = (0, import_classnames2.default)("dig-Modal-header", modalHeaderRecipe({
    marginTitleStandard: hasBottomSpacing === "title-standard"
  }), {
    "dig-Modal-header--margin-title-standard": hasBottomSpacing === "title-standard"
  }, className);
  return /* @__PURE__ */ React2.createElement("div", __spreadValues({ className: cls }, rest), children);
};
Header.displayName = "Header";

// ../src/modal/body.tsx
var React3 = __toESM(require("react"));
var import_classnames3 = __toESM(require("classnames"));
var _excluded3 = ["children", "className", "hasVerticalSpacing"];
function _objectWithoutProperties3(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose3(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Body = React3.forwardRef(function(_ref, ref) {
  var children = _ref.children, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, _ref$hasVerticalSpaci = _ref.hasVerticalSpacing, hasVerticalSpacing = _ref$hasVerticalSpaci === void 0 ? false : _ref$hasVerticalSpaci, rest = _objectWithoutProperties3(_ref, _excluded3);
  var cls = (0, import_classnames3.default)("dig-Modal-body", modalBodyRecipe({
    hasVerticalSpacing: hasVerticalSpacing
  }), className, {
    "dig-Modal-body--hasVerticalSpacing": hasVerticalSpacing
  });
  return /* @__PURE__ */ React3.createElement("div", __spreadValues({ ref: ref, className: cls }, rest), children);
});
Body.displayName = "Body";

// ../src/modal/footer.tsx
var React4 = __toESM(require("react"));
var import_classnames4 = __toESM(require("classnames"));
var _excluded4 = ["hasTopBorder", "children", "className", "preferComposition"];
function _objectWithoutProperties4(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose4(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose4(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Footer = function(_ref) {
  var _ref$hasTopBorder = _ref.hasTopBorder, hasTopBorder = _ref$hasTopBorder === void 0 ? false : _ref$hasTopBorder, children = _ref.children, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, _ref$preferCompositio = _ref.preferComposition, preferComposition = _ref$preferCompositio === void 0 ? false : _ref$preferCompositio, rest = _objectWithoutProperties4(_ref, _excluded4);
  var cls = (0, import_classnames4.default)({
    "dig-Modal-footer": !preferComposition,
    "dig-Modal-prefer-composition-footer": preferComposition,
    "dig-Modal-footer--hasTopBorder": hasTopBorder
  }, modalFooterRecipe({
    preferComposition: preferComposition,
    hasTopBorder: hasTopBorder
  }), className);
  return /* @__PURE__ */ React4.createElement("div", __spreadValues({ className: cls }, rest), children);
};
Footer.displayName = "Footer";

// ../src/modal/title.tsx
var React5 = __toESM(require("react"));
var import_classnames5 = __toESM(require("classnames"));
var import_typography = require("@dropbox/dig-components/typography");
var _excluded5 = ["children", "className"];
function _objectWithoutProperties5(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose5(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose5(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Title = function(_ref) {
  var children = _ref.children, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, rest = _objectWithoutProperties5(_ref, _excluded5);
  var cls = (0, import_classnames5.default)("dig-Modal-title", modalTitleStyle, className);
  return /* @__PURE__ */ React5.createElement(import_typography.Title, __spreadValues({ className: cls }, rest), children);
};
Title.displayName = "Title";

// ../src/modal/full_bleed.tsx
var React6 = __toESM(require("react"));
var import_classnames6 = __toESM(require("classnames"));
var _excluded6 = ["children", "className"];
function _objectWithoutProperties6(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose6(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose6(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var FullBleed = function(_ref) {
  var children = _ref.children, className = _ref.className, rest = _objectWithoutProperties6(_ref, _excluded6);
  var cls = (0, import_classnames6.default)("dig-Modal-full-width", modalFullWidthStyle, className);
  return /* @__PURE__ */ React6.createElement("div", __spreadValues({ className: cls }, rest), children);
};

// ../src/modal/modal.tsx
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var _excluded7 = ["aria-label", "aria-labelledby", "aria-describedby", "children", "className", "fullScreen", "isCentered", "withCloseButton", "width", "open", "shouldCloseOnOverlayClick", "shouldFocusAfterRender", "onRequestClose", "onAfterOpen", "onAfterClose", "overlayClassName", "modalBaseIndex", "parentSelector", "hasAutoFocusClose", "closeButtonProps", "overlayStyles", "contentStyles", "contentOverflow", "data"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties7(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose7(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose7(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var getWidthPx = function(width) {
  switch (width) {
    case "small":
      return 450;
    case "standard":
      return 600;
    case "large":
      return 700;
  }
  return width;
};
var Modal = React7.forwardRef(
  function(_ref, ref) {
    var ariaLabel = _ref["aria-label"], ariaLabelledby = _ref["aria-labelledby"], ariaDescribedby = _ref["aria-describedby"], children = _ref.children, className = _ref.className, _ref$fullScreen = _ref.fullScreen, fullScreen = _ref$fullScreen === void 0 ? false : _ref$fullScreen, _ref$isCentered = _ref.isCentered, isCentered = _ref$isCentered === void 0 ? false : _ref$isCentered, withCloseButton = _ref.withCloseButton, _ref$width = _ref.width, width = _ref$width === void 0 ? "standard" : _ref$width, _ref$open = _ref.open, open = _ref$open === void 0 ? false : _ref$open, _ref$shouldCloseOnOve = _ref.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _ref$shouldCloseOnOve === void 0 ? true : _ref$shouldCloseOnOve, _ref$shouldFocusAfter = _ref.shouldFocusAfterRender, shouldFocusAfterRender = _ref$shouldFocusAfter === void 0 ? true : _ref$shouldFocusAfter, onRequestClose = _ref.onRequestClose, onAfterOpen = _ref.onAfterOpen, onAfterClose = _ref.onAfterClose, overlayClassName = _ref.overlayClassName, _ref$modalBaseIndex = _ref.modalBaseIndex, modalBaseIndex = _ref$modalBaseIndex === void 0 ? import_layer.MODAL_BASE_INDEX : _ref$modalBaseIndex, parentSelector = _ref.parentSelector, _ref$hasAutoFocusClos = _ref.hasAutoFocusClose, hasAutoFocusClose = _ref$hasAutoFocusClos === void 0 ? false : _ref$hasAutoFocusClos, closeButtonProps = _ref.closeButtonProps, overlayStyles = _ref.overlayStyles, contentStyles = _ref.contentStyles, _ref$contentOverflow = _ref.contentOverflow, contentOverflow = _ref$contentOverflow === void 0 ? "visible" : _ref$contentOverflow, data = _ref.data, rest = _objectWithoutProperties7(_ref, _excluded7);
    var contentRef = React7.useRef();
    var _useTheme = (0, import_dig_foundations.useTheme)(), getThemeProps = _useTheme.getThemeProps;
    var cls = (0, import_classnames7.default)("dig-Modal", modalRecipe({
      isCentered: isCentered,
      fullScreen: fullScreen
    }), {
      "dig-Modal--isCentered": isCentered,
      "dig-Modal--fullScreen": fullScreen
    }, className);
    var attachContentRef = React7.useCallback(function(instance) {
      contentRef.current = instance;
    }, []);
    var onClickClose = onRequestClose;
    var focus = React7.useCallback(function() {
      if (contentRef && contentRef.current) {
        contentRef.current.focus();
      }
    }, [contentRef]);
    React7.useImperativeHandle(ref, function() {
      return {
        focus: focus
      };
    }, [focus]);
    var ariaProp = React7.useMemo(function() {
      if (ariaLabelledby === void 0) {
        return void 0;
      }
      return {
        labelledby: ariaLabelledby,
        describedby: ariaDescribedby
      };
    }, [ariaLabelledby, ariaDescribedby]);
    return /* @__PURE__ */ React7.createElement(
      import_react_modal.default,
      __spreadProps(__spreadValues({}, rest), {
        data: data,
        testId: rest.testId || rest["data-testid"],
        aria: ariaProp,
        contentLabel: ariaLabel,
        contentRef: attachContentRef,
        isOpen: open,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldFocusAfterRender: shouldFocusAfterRender,
        onRequestClose: onRequestClose,
        onAfterOpen: onAfterOpen,
        onAfterClose: onAfterClose,
        className: cls,
        bodyOpenClassName: (0, import_classnames7.default)("dig-Modal-body--open", modalHtmlStyle),
        htmlOpenClassName: (0, import_classnames7.default)("dig-Modal-html--open", modalHtmlStyle),
        overlayClassName: (0, import_classnames7.default)(
          "dig-Modal-overlay",
          modalOverlayStyle,
          overlayClassName,
          // We add the theme class names to the root-most container of `Modal`
          getThemeProps().className
        ),
        parentSelector: parentSelector,
        closeTimeoutMS: 200,
        style: {
          overlay: _objectSpread(_objectSpread({}, overlayStyles), {}, {
            // `react-modal` by default portals into the `document.body` and isn't connected to
            // our elevation system. To address this, we need to apply a z-index to the
            // internal overlay rendered by `react-modal` so if there's any elevated
            // components (Menu, Tooltips, etc.) that is rendered within this sub-layer, it will
            // be properly laid at a higher z-index.
            zIndex: modalBaseIndex
          }),
          content: _objectSpread(_objectSpread({}, contentStyles), {}, {
            width: fullScreen ? "100%" : getWidthPx(width)
          })
        }
      }),
      /* @__PURE__ */ React7.createElement(import_layer.LayerContext.Provider, { value: {
        zIndex: modalBaseIndex
      } }, /* @__PURE__ */ React7.createElement(Content, { style: {
        overflow: contentOverflow === "hidden" ? "hidden" : void 0
      } }, children), !!withCloseButton && /* @__PURE__ */ React7.createElement(import_buttons.IconButton, __spreadProps(__spreadValues({ variant: "transparent", "aria-label": withCloseButton, "data-testid": "digModalCloseButton", autoFocus: hasAutoFocusClose }, closeButtonProps), { className: (0, import_classnames7.default)("dig-Modal-close-btn", modalCloseButtonStyle, closeButtonProps === null || closeButtonProps === void 0 ? void 0 : closeButtonProps.className), onClick: function(e) {
        var _closeButtonProps$onC;
        onClickClose === null || onClickClose === void 0 || onClickClose(e);
        closeButtonProps === null || closeButtonProps === void 0 || (_closeButtonProps$onC = closeButtonProps.onClick) === null || _closeButtonProps$onC === void 0 || _closeButtonProps$onC.call(closeButtonProps, e);
      } }), /* @__PURE__ */ React7.createElement(import_dig_icons.UIIcon, { src: import_assets.CloseLine })))
    );
  }
  // Type assertion to enable adding subcomponents as static props below
  // There doesn't seem to be a way to avoid this with current forwardRef typings
  // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757
);
Modal.Content = Content;
Modal.Header = Header;
Modal.Body = Body;
Modal.Footer = Footer;
Modal.Title = Title;
Modal.FullBleed = FullBleed;
Modal.displayName = "Modal";
var setAppElement = function(appElement) {
  import_react_modal.default.setAppElement(appElement);
};
Modal.setAppElement = setAppElement;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Modal
});
